import { render, staticRenderFns } from "./ChipsSelector.vue?vue&type=template&id=778f42fc"
import script from "./ChipsSelector.vue?vue&type=script&lang=js"
export * from "./ChipsSelector.vue?vue&type=script&lang=js"
import style0 from "./ChipsSelector.vue?vue&type=style&index=0&id=778f42fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports